// extracted by mini-css-extract-plugin
module.exports = {"image_holder":"BlogPreviewImageStyle-module--image_holder--3RHdz","large_image":"BlogPreviewImageStyle-module--large_image--1KOS3"};